module.exports = __webpack_public_path__ + "static/media/logo.bd2079f5.png";